import { useDispatch, useSelector } from 'react-redux';
import { IonFooter, IonItem, IonLabel, IonButton, IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';

import { updateUser } from '@/actions/user';
import { stopEverything } from '@/helpers/events';

export default function NotificationBanner() {
  const dispatch = useDispatch();
  const user = useSelector((store) => store.user);

  const dismiss = () => {
    dispatch(updateUser({notifications: {dirty: []}}));
  };

  if (user?.user_type !== 'employee' || !_.isEmpty(user.notifications)) return;

  return (
    <IonFooter>
      <IonItem color="warning" routerLink="/notifications" onClick={dismiss}>
        <IonButton fill="clear" color="medium" onClick={stopEverything(dismiss)}>
          <IonIcon slot="icon-only" icon={closeOutline}/>
        </IonButton>
        <IonLabel>
          <h2>Get Notified!</h2>
          <p className="ion-text-wrap">Click here to get a text message when loads are dropped off.</p>
        </IonLabel>
      </IonItem>
    </IonFooter>
  );
};
